window.gsc = window.gsc || function () { (gsc.q = gsc.q || []).push(arguments) };

